/**
 * Static list of HandyBy categories — used by the sitemap generator and
 * any component that needs to enumerate categories without importing the
 * full CategoryInfo data from App.jsx.
 *
 * Keep in sync with CategoryInfo in src/Public/App.jsx.
 */
const CategoriesData = [
    { Category: "Air Duct", UrlCategory: "Air-Duct" },
    { Category: "Dryer Vent", UrlCategory: "Dryer-Vent" },
    { Category: "Chimney and Fireplace", UrlCategory: "Chimney-Fireplace" },
    { Category: "HVAC", UrlCategory: "HVAC" },
    { Category: "Roofing", UrlCategory: "Roofing" },
    { Category: "Garage Door", UrlCategory: "Garage-Door" },
    { Category: "Locksmith", UrlCategory: "Locksmith" },
    { Category: "Insulation", UrlCategory: "Insulation" },
];

export default CategoriesData;
